





















































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { secondsToText, getPropertyByKeys } from "../utils";
import consts from "../consts";
import axios from "axios";

@Component
export default class FeedbackVideo extends Vue {
  @Prop() private url!: string;
  @Prop() private data!: any;
  @Prop() private JWT!: string;
  @Prop() private localJWT!: string;
  @Prop() private sessionID!: string;
  @Prop() private startIndex!: number;
  @Prop() private viewOnly!: boolean;
  @Prop() private shareOnly!: boolean;
  private video?: HTMLVideoElement;
  private editor: any = null;
  private duration: number = 0;
  private elapsed: string = "0:00";
  private total: string = "";
  private scrubberLeft: number = 0;
  private currentTrack: string = "";
  private currentBlock: number = 0;
  private labelWidth: number = 80;
  private startTimes: number[] = [];

  private mounted() {
    // this.calcTotalTime();
    this.setupVideo();
    this.fetchSessionTranscript();
  }

  private beforeDestroy() {}

  private setupVideo() {
    this.video = this.$refs.video as HTMLVideoElement;
    const video = this.video!;

    video.onloadeddata = () => {
      this.total = secondsToText(video.duration);
      this.duration = video.duration * 1000;
    };

    video.ontimeupdate = () => {
      this.elapsed = secondsToText(video.currentTime);
      let perc = video.currentTime / video.duration;
      let trackWidth = (this.$refs.tracks as HTMLElement).clientWidth;
      this.scrubberLeft = perc * (trackWidth - this.labelWidth);

      // Find current emotion
      let mil = video.currentTime * 1000;
      if (this.data && this.data.emotions && this.data.emotions.length) {
        this.currentTrack = "";
        this.currentBlock = 0;
        for (let i = 0; i < this.data.emotions.length; ++i) {
          if (
            this.data.emotions[i].start_time <= mil &&
            this.data.emotions[i].end_time >= mil
          ) {
            this.currentTrack = this.data.emotions[i].emotion;
            this.currentBlock = this.data.emotions[i].start_time;
            break;
          }
        }
      }
    };
  }

  private handleBarClick(e: MouseEvent) {
    let target = e.target as HTMLElement;
    if (
      this.video &&
      target &&
      (target.classList.contains("track-wrapper") ||
        target.classList.contains("block"))
    ) {
      let tracksEl = this.$refs.tracks as HTMLElement;
      let tracksElRect = tracksEl.getBoundingClientRect() as DOMRect;
      let offset = e.pageX - tracksElRect.left - this.labelWidth;
      let perc = offset / (tracksElRect.width - this.labelWidth);
      let currentTime = perc * this.video.duration;
      this.video.currentTime = currentTime;
    }
  }

  private addVideoFeedback() {
    if (this.video) {
      this.video.pause();
      let i = 0;
      for (i = 0; i < this.startTimes.length; i++) {
        if (this.video.currentTime < this.startTimes[i]) {
          i = Math.max(0, i - 1); // Get previous word
          break;
        }
      }
      this.$emit("addVideoFeedback", i);
    }
  }

  // private calcTotalTime() {
  //   if (this.data.emotions && this.data.emotions.length) {
  //     let len = this.data.emotions.length;
  //     this.duration = this.data.emotions[len - 1].end_time;
  //   }
  // }

  private calcBlockStyle(emotion: any) {
    let styleObj: any = {
      width:
        ((emotion.end_time - emotion.start_time) / this.duration) * 100 + "%",
      left: (emotion.start_time / this.duration) * 100 + "%"
    };
    if (this.currentBlock === emotion.start_time) {
      styleObj.opacity = 1;
    }
    return styleObj;
  }

  private filteredEmotions(type: string) {
    if (this.data && this.data.emotions && this.data.emotions.length) {
      return this.data.emotions.filter((emotion: any) => {
        return emotion.emotion === type;
      });
    }
    return [];
  }

  private fetchSessionTranscript() {
    let jwt = this.viewOnly ? this.localJWT : this.JWT;
    axios
      .get(consts.serverURL + "session/" + this.sessionID, {
        headers: { Authentication: jwt }
      })
      .then(resp => {
        console.log("VIDEO SESSION", resp.data);
        if (resp.data.Results) {
          let results = JSON.parse(resp.data.Results);
          let startTimes = getPropertyByKeys(results, [
            "Results",
            "StartTimes"
          ]);
          this.startTimes = startTimes || [];
        }
      });
  }

  @Watch("url")
  private onUrlChanged() {
    this.elapsed = "0:00";
    this.scrubberLeft = 0;
    this.currentTrack = "";
    this.currentBlock = 0;
    this.setupVideo();
  }

  @Watch("startIndex")
  private onStartIndexChanged() {
    console.log(this.startIndex);
    if (this.video && this.startIndex < this.startTimes.length) {
      this.video.currentTime = this.startTimes[this.startIndex];
    }
  }
}
